var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('b-card',{class:'main'},[_c('h1',[_vm._v(_vm._s(_vm.$t("messages.not_found_title")))]),_c('p',[_vm._v(_vm._s(_vm.$t("messages.not_found_body")))])]),(!_vm.api_token)?_c('LoginForm'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }